import { SearchGroup } from '../models/enums';
import { Member } from '../models/member';

function matchesName(member: Member, searchKey: string): boolean {
  return `${member.firstName} ${member.lastName}`.toLocaleLowerCase().includes(searchKey.toLocaleLowerCase());
}

export function memberSearchFilter(primary: Member, dependents: Member[], searchKey: string, searchGroup: SearchGroup) {
  if (searchGroup === SearchGroup.ALL) {
    return matchesName(primary, searchKey) || dependents.some(dependent => matchesName(dependent, searchKey));
  } else if (searchGroup === SearchGroup.PRIMARIES) {
    return matchesName(primary, searchKey);
  } else if (searchGroup === SearchGroup.DEPENDENTS) {
    return dependents.some(dependent => matchesName(dependent, searchKey));
  }
}
